import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FirstScreen from "./FirstScreen";
import Home from "./Home";
import Explore from "./Explore";
import Cart from "./Cart";
import SavedCarts from "./SavedCarts";
import Alerts from "./Alerts";
import Account from "./Account";
import Footer from "./Footer";
import withRouter from "../../withRouter";

const Mobile = (props) => {
  const [showGdpr, setShowGdpr] = useState(false);
  const hasAddress = Boolean(localStorage.getItem("userSetAddress"));

  useEffect(() => {
    if (!localStorage.getItem("gdprAccepted")) {
      localStorage.setItem("gdprAccepted", "false");
    }

    if (
      localStorage.getItem("showGdpr") === "true" &&
      localStorage.getItem("gdprAccepted") === "false"
    ) {
      setShowGdpr(true);
    }
  }, []);

  const handleGdprClick = () => {
    localStorage.setItem("gdprAccepted", "true");
    setShowGdpr(false);
  };

  return (
    <>
      {showGdpr && (
        <div className="fixed-gdpr-mobile">
          <span
            dangerouslySetInnerHTML={{
              __html: localStorage.getItem("gdprMessage"),
            }}
          />
          <button
            className="btn btn-sm ml-2"
            style={{ backgroundColor: localStorage.getItem("storeColor") }}
            onClick={handleGdprClick}
          >
            {localStorage.getItem("gdprConfirmButton")}
          </button>
        </div>
      )}

      {!hasAddress ? (
        <FirstScreen languages={props.languages} />
      ) : (
        <>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/my-carts" element={<SavedCarts />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/my-account" element={<Account />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <Footer />
        </>
      )}
    </>
  );
};

export default withRouter(Mobile);
